module.exports = __webpack_public_path__ + "static/euromaster-8d4b156921469ac779e9c844c1168eb6.png";